import { requestType } from '~/config/enum.config';
var SERVICE = 'common-service';
var CONTROLLER = 'reminderMessageController';
export default {
    /**
     * 获取未读消息数
     */
    getUnReadCount: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'unReadCount',
        type: requestType.Get
    },
    /**
     * 通过登陆用户token查询消息列表
     */
    getReminderMessages: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'query',
        type: requestType.Get
    },
    /**
     * 设置消息状态为已读
     */
    setSelectedMessageRead: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'readIt',
        type: requestType.Get
    },
    /**
     * 批量删除消息
     */
    batchDelete: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'batchDelete',
        type: requestType.Delete
    },
    /**
     * 删除消息
     */
    delete: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'delete',
        type: requestType.Post
    },
    /**
     * 取弹框三条消息
     */
    getWorkbenchReminder: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'getWorkbenchReminder',
        type: requestType.Get
    }
};
